<template>
  <div class="container">
    <div class="map-container" ref="mapContainer">
    <div class="mappp">
        <transition name="fade">
          <img v-if="isWorldMapVisible" :src="mapImg" alt="World Map" class="map" />
        </transition>
        <div v-for="(line, index) in lines" :key="index" class="line-container">
          <transition name="slide-in">
            <img class="map_xiao" v-if="line.visible" :src="line.src" :class="line.class"/>
          </transition>
    </div>
      <!-- <transition name="point-fade">
        <p  v-if="isLocationVisible"  class="point" :style="{ top: line.pointTop + 'px', left: line.pointLeft + 'px' }">{{line.pointSrc}}</p>
      </transition> -->
    </div>
    </div>
    <!-- 其他内容... -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isWorldMapVisible: false,
      isBranchLineVisible: false,
      isLocationVisible: false,
      lastScrollTop: 0,
      showMap: false,
      mapImg:require('../../assets/images/map/tu1 (1).png'),
      lines: [
        { src: require('../../assets/images/map/tu1 (2).png'), class: 'line map_xiao_1', visible: false, pointSrc: '../../assets/images/map/tu1 (2).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (3).png'), class: 'line map_xiao_2', visible: false, pointSrc: '../../assets/images/map/tu1 (3).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (4).png'), class: 'line map_xiao_3', visible: false, pointSrc: '../../assets/images/map/tu1 (4).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (5).png'), class: 'line map_xiao_4', visible: false, pointSrc: '../../assets/images/map/tu1 (5).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (6).png'), class: 'line map_xiao_5', visible: false, pointSrc: '../../assets/images/map/tu1 (6).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (7).png'), class: 'line map_xiao_6', visible: false, pointSrc: '../../assets/images/map/tu1 (7).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (8).png'), class: 'line map_xiao_7', visible: false, pointSrc: '../../assets/images/map/tu1 (8).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (9).png'), class: 'line map_xiao_8', visible: false, pointSrc: '../../assets/images/map/tu1 (9).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (10).png'), class: 'line map_xiao_9', visible: false, pointSrc: '../../assets/images/map/tu1 (10).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (11).png'), class: 'line map_xiao_10', visible: false, pointSrc: '../../assets/images/map/tu1 (11).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (12).png'), class: 'line map_xiao_11', visible: false, pointSrc: '../../assets/images/map/tu1 (12).png', pointTop: 120, pointLeft: 230, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (13).png'), class: 'line map_xiao_12', visible: false, pointSrc: '../../assets/images/map/tu1 (13).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (14).png'), class: 'line map_xiao_13', visible: false, pointSrc: '../../assets/images/map/tu1 (14).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (15).png'), class: 'line map_xiao_14', visible: false, pointSrc: '../../assets/images/map/tu1 (15).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (16).png'), class: 'line map_xiao_15', visible: false, pointSrc: '../../assets/images/map/tu1 (16).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (17).png'), class: 'line map_xiao_16', visible: false, pointSrc: '../../assets/images/map/tu1 (17).png', pointTop: 170, pointLeft: 330, pointVisible: false },
        { src: require('../../assets/images/map/tu1 (18).png'), class: 'line map_xiao_17', visible: false, pointSrc: '../../assets/images/map/tu1 (18).png', pointTop: 170, pointLeft: 330, pointVisible: false },

        // 添加更多线
      ],
      animationSteps: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const mapContainer = this.$refs.mapContainer;
      if (mapContainer) {
        const rect = mapContainer.getBoundingClientRect();
        const isInmapContainer = rect.top < window.innerHeight && rect.bottom > 0;

        // 检查是否向上滚动且进入地图区域
        if (isInmapContainer && scrollTop > this.lastScrollTop) {
          this.resetVisibility(); // 确保每次进入时都重置可见性
          this.showElementsSequentially();
        }
        // else{
        //   this.resetVisibilityAA()
        // }

        // 更新最后滚动位置
        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
      }
    },
    resetVisibility() {
      this.isWorldMapVisible = true;
      this.isBranchLineVisible = true;
      this.isLocationVisible = true;
    },
    resetVisibilityAA() {
      this.isWorldMapVisible = false;
      this.isBranchLineVisible = false;
      this.isLocationVisible = false;
    },
    showElementsSequentially() {
      // this.isWorldMapVisible = true;
      // setTimeout(() => {
      //   this.isBranchLineVisible = true;
      //   setTimeout(() => {
      //     this.isLocationVisible = true;
      //   }, 500); // 延迟 500ms 后显示支线
      // }, 500); // 延迟 500ms 后显示世界地图
      setTimeout(() => {
        this.showMap = true;
      }, 1000); // 立即显示地图

      setTimeout(() => {
        this.lines.forEach((line, index) => {
          setTimeout(() => {
            line.visible = true;
          }, index * 500); // 每条线间隔500ms显示
        });
      }, 2000); // 地图显示1秒后显示线
 
      setTimeout(() => {
        this.lines.forEach((line) => {
          setTimeout(() => {
            line.pointVisible = true;
          },  (this.lines.indexOf(line) + 1) * 500); // 每条线指向的点在线显示后2秒再显示，且每条线间隔500ms
          // }, 2000 + (this.lines.indexOf(line) + 1) * 500); // 每条线指向的点在线显示后2秒再显示，且每条线间隔500ms
        });
      }, 3000); // 所有线显示完毕后2秒显示点
    },
  },
};
</script>

<style scoped>
.map-container {
  position: relative;
}

.world-map,
.branch-line,
.location {
  opacity: 0;
  transition: opacity 1s ease-in-out;
}

.world-map.visible,
.branch-line.visible,
.location.visible {
  opacity: 1;
}

#app {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #f0f0f0;
  overflow: hidden;
}



.line-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.line {
  position: absolute;
  width: auto;
  height: auto;
}

.point {
  position: absolute;
  width: 20px;
  height: 20px;
}

/* 动画效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.slide-in-enter-active {
  transition: transform 1s ease-out, opacity 1s ease-out;
  transform: translateY(20px);
  opacity: 0;
}
.slide-in-leave-active {
  transition: transform 1s ease-in, opacity 1s ease-in;
  transform: translateY(-20px);
  opacity: 0;
}
.slide-in-enter, .slide-in-leave-to /* .slide-in-leave-active in <2.1.8 */ {
  transform: translateY(0);
  opacity: 1;
}

.point-fade-enter-active, .point-fade-leave-active {
  transition: opacity 1s;
}
.point-fade-enter, .point-fade-leave-to /* .point-fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.mappp{
  width: 1432px;
    height: 728px;
  position: relative;
  margin: 0 auto;
  
}
.map {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: auto;
}
.map{
    width: 1432px;
    height: 728px;
  }


  
  .map_xiao{
    position: absolute;
  }
  
  .map_xiao_1{
    top: 344px; 
    left: 1152px;
    width:107px;
    height:56px;
  }
  .map_xiao_2{
    top: 375px;
    left: 1121px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_3{
    top: 462px;
     left: 960px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_4{
    top: 222px;
    left: 1141px;
    width:137px;
    height:121px;
    
  }
  .map_xiao_5{
    top: 135px;
    left: 572px;
    width:115px;
    height:106px;
    
  }
  .map_xiao_6{
    top: 326px;
     left: 73px;
    width:131px;
    height:87px;
  }
  .map_xiao_7{
    top: 285px;
     left: 358px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_8{
    top: 291px;
     left: 1219px;
    width:114px;
    height:48px;
    
  }
  .map_xiao_9{
    top: 348px;
     left: 272px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_10{
    top: 237px;
     left: 66px;
    width:114px;
    height:48px;
    
  }
  .map_xiao_11{
    top: 227px;
     left: 362px;
    width:138px;
    height:48px;
    
  }
  .map_xiao_12{
    top: 436px;
     left: 545px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_13{
    top: 592px;
     left: 423px;
    width:127px;
    height:49px;
    
  }
  .map_xiao_14{
    top: 613px;
     left: 1263px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_15{
    top: 391px;
     left: 837px;
    width:126px;
    height:87px;
    
  }
  .map_xiao_16{
    top: 346px;
     left: 879px;
    width:116px;
    height:48px;
    
  }
  .map_xiao_17{
    top: 585px;
     left: 257px;
    width:130px;
    height:48px;
    
  }
</style>
